if (!customElements.get('product-shop-look-drawer')) {
  customElements.define(
    'product-shop-look-drawer',
    class ProductShopLookDrawer extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.product-shop-look__drawer-panel');
        this.closeButtons = this.querySelectorAll('[data-product-shop-look-close]');

        this.closeButtons.forEach(button => {
          button.addEventListener('click', this.close.bind(this));
        });

        this.addEventListener('click', event => {
          if (event.target.closest('.quick-cart-drawer__trigger')) {
            this.close();
          }
        });

        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            this.close();
          }
        });
      }

      open(trigger) {
        this.activeTrigger = trigger;
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');

        if (trigger) {
          trigger.setAttribute('aria-expanded', 'true');
        }

        if (this.panel) {
          this.panel.focus();
        }
      }

      close() {
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');

        document.querySelectorAll(`[data-product-shop-look-open="${this.id}"]`).forEach(trigger => {
          trigger.setAttribute('aria-expanded', 'false');
        });

        if (this.activeTrigger) {
          this.activeTrigger.focus();
        }
      }
    }
  );
}

if (!window.productShopLookDrawerListener) {
  window.productShopLookDrawerListener = true;

  const bindProductShopLookQuickAdd = () => {
    const quickCartDrawer = document.querySelector('quick-cart-drawer');
    if (!quickCartDrawer || typeof quickCartDrawer.fetchProductForQuickCartDrawer !== 'function') return;

    document.querySelectorAll('.product-shop-look__quick-add').forEach(trigger => {
      if (trigger._init) return;

      trigger.addEventListener('click', event => {
        quickCartDrawer.fetchProductForQuickCartDrawer(event);
      });
      trigger._init = true;
    });
  };

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-product-shop-look-open]');
    if (!trigger) return;

    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const drawer = document.getElementById(trigger.dataset.productShopLookOpen);
    if (!drawer) return;

    event.preventDefault();
    drawer.open(trigger);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindProductShopLookQuickAdd);
  } else {
    bindProductShopLookQuickAdd();
  }

  window.addEventListener('load', bindProductShopLookQuickAdd);
  document.addEventListener('shopify:section:load', bindProductShopLookQuickAdd);
}
